export default {
	calculatedRate: {
		fromQuantity: 1,
		toCurrency: null,
		fromCurrency: null,
		isSwitched: false
	}
}